import { Box, Button, Flex, Icon, IconButton, Stack } from '@chakra-ui/react';
import Header from '@components/typography/Header';
import { Routes } from '@constants/routes';
import { antlerStyle } from '@constants/styles';
import { faArrowLeft, faExternalLink } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Link from 'next/link';

const VideoResource = ({ title, buttonLabel, href, videoURL }) => {
  return (
    <Stack px={antlerStyle.px} w="100%" mx="auto" align="center" py={24} spacing={12} bg="darkBackground">
      <Flex alignItems="center" gap={6}>
        <Link href={Routes.dashboard}>
          <IconButton
            icon={<Icon as={FontAwesomeIcon} icon={faArrowLeft} />}
            aria-label="Back Arrow"
            variant="outline"
            bg="white"
          />
        </Link>
        <Header as="h1">{title}</Header>
      </Flex>
      <Box h={['240px', '400px']} w="100%" maxW="700px">
        <iframe title={title} width="100%" height="100%" src={videoURL} allowFullScreen />
      </Box>
      <Link href={href}>
        <Button colorScheme="primary" rightIcon={<Icon as={FontAwesomeIcon} icon={faExternalLink} />}>
          {buttonLabel}
        </Button>
      </Link>
    </Stack>
  );
};

export default VideoResource;
